import {Device} from "../Device";

export default class PT300 extends Device {

  constructor(data: any) {
    super(data);
  }

}
